import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyWeddingPass = loadable(() => import(/* webpackChunkName: "content/wallet/pass" */ '.'), 'WeddingPass');
